import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api/client';

export default function Lesson() {
  const { id } = useParams();
  const lessonId = Number(id);
  const [lesson, setLesson] = useState(null);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!lessonId) return;
    let mounted = true;
    api.lesson(lessonId)
      .then((l) => { if (mounted) setLesson(l); return api.getLessonProgress(lessonId).catch(() => null); })
      .then((p) => mounted && setProgress(p))
      .catch((e) => mounted && setError(e.message));
    return () => { mounted = false; };
  }, [lessonId]);

  const startLesson = async () => {
    if (!lesson) return;
    try {
      const p = await api.createOrUpdateProgress({ lesson_id: lesson.id, skill_id: lesson.skill_id, status: 'in_progress' });
      setProgress(p);
    } catch (e) { setError(e.message); }
  };

  const completeLesson = async () => {
    if (!lesson) return;
    try {
      const p = await api.createOrUpdateProgress({ lesson_id: lesson.id, skill_id: lesson.skill_id, status: 'completed', score: 100, time_spent: 300 });
      setProgress(p);
    } catch (e) { setError(e.message); }
  };

  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!lesson) return <div>Loading lesson...</div>;

  return (
    <div style={{ padding: 16 }}>
      <h2>{lesson.title}</h2>
      <div>Difficulty: {lesson.difficulty}</div>
      <div style={{ whiteSpace: 'pre-wrap', marginTop: 12 }}>{lesson.content}</div>
      <div style={{ marginTop: 16 }}>
        <button onClick={startLesson}>Start</button>
        <button onClick={completeLesson} style={{ marginLeft: 8 }}>Complete</button>
      </div>
      {progress && (
        <div style={{ marginTop: 12 }}>
          <div>Status: {progress.status}</div>
          <div>Score: {progress.score}</div>
          <div>Time spent: {progress.time_spent}s</div>
        </div>
      )}
    </div>
  );
}
